module.exports = __webpack_public_path__ + "static/media/practiseguro-clausulas.d63ab099.pdf";